import ChecklistRequirements from 'views/components/Validation/ChecklistRequirements/ChecklistRequirements';

export default ChecklistRequirements;
